// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3Gjat","rootSmall":"AddTileButton_rootSmall__3PbFH"};